// inputFieldSlices/propertyInputSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  formData: {
    dcode: "",
    srocode: "",
    deedcode: "",
    subDeedCode: "",
    segmentcode: "",
    rateyear: "",
    location: "", // <-- To be persisted
    locationCircleRate: "", // <-- To be persisted
    secDcode: "",
    secSrocode: "",
    selectedVillageIndex: "",
    mutationDepartment: "",
    mutationOfficeCode: "",
    disableFlag: false,
    femaleBuyer: false,
    armyFlag: false,
    coOwnerFlag: false,
    selectedNumber: null,
    khewat: "",
    houseNo: "",
    area: null,
    unit: "",
    khatoni: "",
    latitude: "",
    longitude: "",
    khasra: "",
    floorno: "",
    riderCode: "",
    east: "",
    west: "",
    north: "",
    south: "",
  }, // Initial form state
  //   isSaved: false,
};

const propertyInputSlice = createSlice({
  name: "propertyInput",
  initialState,
  reducers: {
    updatePropertyForm: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
      //debugger;
      console.log(state.formData);
      //debugger;
      console.log(state.formData);
    },
    // Adding this for trial
    clearOnDeedChange: (state) => {
      debugger;
      const { dcode, srocode } = state.formData;
      state.formData = {
        ...initialState.formData,
        dcode,
        srocode,
      };
    },
    clearOnRateListChange: (state) => {
      const { dcode, srocode, deedcode, subDeedCode } = state.formData;
      state.formData = {
        ...initialState.formData,
        dcode,
        srocode,
        deedcode,
        subDeedCode,
      };
    },
    resetPropertyForm: (state) => {
      state.formData = initialState.formData;
      //   state.isSaved = false;
    },
    setFormSaveStatus: (state, action) => {
      state.isSaved = action.payload; // Set save status
    },
    setInitialState: (state, action) => {
      state.formData = action.payload;
      console.log("initialState:", action.payload);
    },
  },
});

export const {
  updatePropertyForm,
  clearOnDeedChange,
  clearOnRateListChange,
  resetPropertyForm,
  setFormSaveStatus,
  setInitialState,
} = propertyInputSlice.actions;
export default propertyInputSlice.reducer;
